import {MappedWirtschaftsjahrAngaben} from '@utils-lib';

const start = 0;
const position2 = 2;
const position4 = 4;
const position6 = 6;
const position8 = 8;

const STANDARD_YEAR_SHORT = '0101';
const STANDARD_YEAR_LONG = '01013112';

export class WirtschaftsjahrHelper {

    public static mapWirtschaftsJahrDaten(wirtschaftsJahr: string): MappedWirtschaftsjahrAngaben {
        if (!wirtschaftsJahr || (wirtschaftsJahr.length !== 4 && wirtschaftsJahr.length !== 8)) {
            return undefined;
        }

        // standard year
        if (wirtschaftsJahr === STANDARD_YEAR_SHORT || wirtschaftsJahr === STANDARD_YEAR_LONG) {
            return {
                isAbweichend: false,
                von: null,
                bis: null
            };
        }

        const dayFrom = Number(wirtschaftsJahr.slice(start, position2));
        const monthFrom = Number(wirtschaftsJahr.slice(position2, position4)) - 1;
        const monthCurrent = new Date().getMonth();
        let yearFrom = new Date().getFullYear();
        // if index of month is equal or less to current, from starts next year
        if (monthFrom <= monthCurrent) {
            yearFrom = yearFrom + 1;
        }

        const dateFrom = new Date(yearFrom, monthFrom, dayFrom);
        const dateTo = this.getToDate(dateFrom, wirtschaftsJahr);
        return {
            isAbweichend: true,
            von: this.formatDate(dateFrom),
            bis: this.formatDate(dateTo)
        };
    }

    private static getToDate(dateFrom: Date, wirtschaftsJahr: string): Date {
        // if only date from is defined, date to is calculated plus 1 year minus 1 day
        // else if date to is defined, date to is parsed and year to calculated
        if (wirtschaftsJahr.length === 4) {
            const dateTo = new Date(dateFrom);
            dateTo.setFullYear(dateTo.getFullYear() + 1);
            dateTo.setDate(dateTo.getDate() - 1);

            return dateTo;
        } else {
            const dayTo = Number(wirtschaftsJahr.slice(position4, position6));
            const monthTo = Number(wirtschaftsJahr.slice(position6, position8)) - 1;
            const dateTo = new Date(dateFrom.getFullYear(), monthTo, dayTo);
            if (dateTo < dateFrom) {
                dateTo.setFullYear(dateTo.getFullYear() + 1);
            }

            return dateTo;
        }
    }

    // return date in required format, adjust month indexing
    private static formatDate(date: Date): string {
        return `${this.addLeadingZero(date.getDate().toString())}.` +
            `${this.addLeadingZero((date.getMonth() + 1).toString())}` +
            `.${date.getFullYear()}`;
    }

    // if number is single digit, add leadig zero
    private static addLeadingZero(value: string): string {
        if (value.length === 1) {
            return '0' + value;
        }
        return value.toString();
    }
}
